import {
  CONTRACTS_FETCH,
  CONTRACTS_DOWNLOAD,
  INITIATE_CONTRACTS_FETCH,
  ORDER_OPTIONS_FETCH,
  SEND_CO_BUYER_EMAIL,
  SET_CONTRACTS_TOAST,
  RESET_CONTRACTS_TOAST
} from './actionTypes';

const initialState = {
  isLoading: false,
  contractsIsLoaded: false,
  isError: false,
  contractsStatus: '',
  contractsSigned: false,
  contractsSignedDateTime: '',
  coBuyerContractsStatus: '',
  docuSignEnvelopeId: '',
  fetchContractsCTA: false,
  iFrameUrl: '',
  saleId: 0,
  sendingCoBuyerEmail: false,
  hasCoBuyer: false,
  contractsToast: null
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${INITIATE_CONTRACTS_FETCH}`:
      return {
        ...state,
        fetchContractsCTA: true
      };

    case `${CONTRACTS_FETCH}_LOADING`:
      return {
        ...state,
        isLoading: true,
        fetchContractsCTA: false
      };

    case `${CONTRACTS_DOWNLOAD}_LOADING`:
      return {
        ...state,
        isLoading: true
      };

    case `${CONTRACTS_FETCH}_SUCCESS`:
      return {
        ...state,
        ...payload,
        isLoading: false,
        isError: false,
      };

    case `${CONTRACTS_DOWNLOAD}_SUCCESS`:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case `${CONTRACTS_FETCH}_ERROR`:
    case `${CONTRACTS_DOWNLOAD}_ERROR`:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: payload,
      };

    case `${ORDER_OPTIONS_FETCH}_LOADING`:
      return {
        ...state
      };

    case `${ORDER_OPTIONS_FETCH}_SUCCESS`:
      return {
        ...state,
        ...payload,
        contractsSigned: payload?.contractsStatus === 'SigningComplete',
      };

    case `${ORDER_OPTIONS_FETCH}_ERROR`:
      return {
        ...state
      };

    case `${SEND_CO_BUYER_EMAIL}_LOADING`:
      return {
        ...state,
        sendingCoBuyerEmail: true
      };

    case `${SEND_CO_BUYER_EMAIL}_SUCCESS`:
      return {
        ...state,
        coBuyer: {
          ...state.coBuyer,
          emailSent: true
        },
        sentCoSignerEmail: true,
        sendingCoBuyerEmail: false
      };

    case `${SEND_CO_BUYER_EMAIL}_ERROR`:
      return {
        ...state,
        sentCoSignerEmail: false,
        sendingCoBuyerEmail: false
      };

    case `${SET_CONTRACTS_TOAST}`:
      return {
        ...state,
        contractsToast: payload
      };

    case `${RESET_CONTRACTS_TOAST}`:
      return {
        ...state,
        contractsToast: null
      };

    default:
      return state;
  }
};

export default reducer;
